"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocalPresence() {
  const {
    ref: headingRef,
    isVisible: headingVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: titleRef,
    isVisible: titleVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: textVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="localpresence" className="py-16 px-4 text-center !bg-transparent !opacity-[100] !text-[hsl(0,0%,100%)] !bg-[url(https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/KS_backimage.jpg)] !bg-[url(https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/KS_backimage.jpg)] !bg-[url(https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/KS_backimage.jpg)] !bg-[url(https://ksluxury.cloudtech.com.cy/wp-content/uploads/2026/02/KS_backimage.jpg)] !shadow-none md:py-24">
      <div className="max-w-5xl mx-auto flex flex-col items-center">

        <div ref={headingRef} className={`mb-4 transition-all duration-700 ${headingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="text-sm tracking-[0.2em] uppercase font-semibold !text-[hsl(7,64%,38%)]">
            LOCAL PRESENCE & TRUST
          </p>
        </div>

        <div ref={titleRef} className={`mb-12 transition-all duration-700 delay-100 ${titleVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-4xl font-display font-bold leading-tight !text-[hsl(0,0%,100%)] md:text-5xl lg:text-[3rem]">Based in Limassol. Serving All of Cyprus</h2>
        </div>

        <div ref={textRef} className={`flex justify-center transition-all duration-700 delay-200 ${textVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="leading-relaxed max-w-3xl !text-[hsl(0,0%,100%)]">Operating from Limassol, <span className="font-semibold">KS LUXURY RENOVATIONS</span> undertakes projects across Cyprus, working with homeowners, developers, and businesses seeking a dependable partner for luxury renovations. Our reputation is built on transparency, consistency, and results that speak for themselves.</p>
        </div>

      </div>
    </section>;
}